export const layout = {
  sidebarWidth: 240,
  adminSidebarWidth: 260,
  headerHeight: 56,
  appHeaderSearchMaxWidth: 560,
  logoWidth: 185,
  logoMaxHeight: 28,
  logoIconSize: 24,
  sidebarBackground: 'background.paper',
} as const;
